import {
  CREATE,
  DELETE,
  GET_LIST,
  GET_ONE,
  UPDATE,
} from 'react-admin'

export function request(apiUrl, type, params) {
  let url = apiUrl + '/admin/events/points'
  let options = {}

  switch (type) {
    case CREATE:
      options.method = 'POST'
      options.data = params.data
      break
    case GET_LIST:
      url += `/list`
      const {page, perPage} = params.pagination
      const {field, order} = params.sort
      options.params = {
        ...params.filter,
        sort: field,
        order: order,
        start: (page - 1) * perPage,
        perPage: perPage,
      }
      break
    case GET_ONE:
      url += `/detail/${params.id}`
      break
    case UPDATE:
      url += `/update/${params.id}`
      options.method = 'PUT'
      options.data = params.data
      break
    case DELETE:
      url += `/${params.id}`
      options.method = 'DELETE'
      break
    default:
      break
  }
  return {url, ...options}
}

export function response(res, type, params) {
  let ret = {}
  const {data} = res
  switch (type) {
    case GET_ONE:
      data.id = data.name
      ret = {data}
      break
    case GET_LIST:
      data.list.map(row => row.id = row.name)
      ret = {data: data.list, total: data.total}
      break
    default:
      if (data) ret = {data}
      break
  }
  return ret
}
